// This is designed to show marketing sub unit only when Melbourne is selected in marketing unit.

export function SetMarketingUnitListener() {
    document.getElementById("marketing-unit-select").addEventListener('input', function () {

        if(this.value === "mel"){
            document.getElementById("marketing-sub-unit-container").hidden = false;
        } else {
            
            document.getElementById("marketing-sub-unit-select").selectedIndex = 0; // 0 is the -- select an option -- value, set to -1 if you want nothing selected
            document.getElementById("marketing-sub-unit-container").hidden = true;
        }

    }, false);
}
